import React, { useState, useEffect } from "react";
import { Card, CardBody } from "reactstrap";
import {
  getClassAvailability,
  getCourseDetailsForfeedback,
  updateTimeTable,
} from "../../../../actions/feedActions";
import CheckOutComponent from "../CheckOutComponent";
import * as Scroll from "react-scroll";

const DemoFeedback = (props) => {
  const [readMore1, setreadMore1] = useState(false);
  const [readMore2, setreadMore2] = useState(false);
  const [courseDetails, setcourseDetails] = useState("");
  const [courseDetailsTable, setcourseDetailsTable] = useState("");
  const [availableTimings, setavailableTimings] = useState([]);
  const [showMoreDetails, setshowMoreDetails] = useState(false);

  useEffect(() => {
    getClassAvailability(props.courseId).then((res) => {
      setavailableTimings(res.data.result);
      console.log("Response of available class", res);
    });
    getCourseDetailsForfeedback(props.courseId)
      .then((res) => {
        setcourseDetails(res.data.result.course);
        if (res.data.result.course.course_features !== null) {
          var courseFeature = JSON.parse(res.data.result.course.course_features);
          var featureArray = [];
          Object.keys(courseFeature).map((id, key) => {
            featureArray.push({
              feature: courseFeature[id].feature,
              value: courseFeature[id].value,
            });
          });

          //convert
          var result = {};
          for (var i = 0; i < featureArray.length; i++) {
            result[featureArray[i].feature.replace(/ +/g, "")] = featureArray[i].value;
          }
          setcourseDetailsTable(result);

          console.log("Single Object", result);
        }
      })
      .catch((err) => {});
  }, []);

  const teacherSelected = (teacherId) => {
    updateTimeTable(props.courseId, teacherId, props.studentId, props.programId)
      .then((res) => {})
      .catch((err) => {
        debugger;
      });
  };

  const formatPrice = (x) => {
    try {
      if (x && x != undefined && x != null) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else if (x == 0) {
        return x;
      }
    } catch (e) {
      console.log("formatPrice:", e);
      return 0;
    }
  };

  const scrollKaro = () => {
    let scroll = Scroll.animateScroll;
    scroll.scrollMore(550);
  };

  const returnListTimings = (courseTimings) => {
    let daysArary = [];

    var timings = courseTimings;
    timings = JSON.parse(timings);
    console.log("TIMINGS", timings);
    Object.keys(timings).map((id, key) => {
      var day = timings[id];
      if (day.start != "" && day.end != "") {
        var start_time = day.start;
        var firstCharStart = start_time.split("");
        if (firstCharStart[0] == "0") {
          start_time = start_time.substring(1);
        }

        var end_time = day.end;
        var firstCharEnd = end_time.split("");
        if (firstCharEnd[0] == "0") {
          end_time = end_time.substring(1);
        }

        var dayName = day.day.split("");

        let dayData = (
          <li key={key}>
            {day.day}
            <span className="">
              {start_time} - {end_time}
            </span>
          </li>
        );
        daysArary.push(dayData);
        console.log(start_time, end_time);
      }
    });
    return daysArary;
  };

  const { feedData, studentName } = props;
  console.log("student Name", props.studentName);
  debugger;
  const secondSection = feedData["secondSection"][0][studentName].split(".");
  const thirdSection = feedData["thirdSection"][0][studentName].split(".");
  console.log("Feedback", props.feedData);

  return (
    <div className="feedbackSection">
      {!readMore1 ? (
        <label className="mt-3">
          {studentName} {secondSection[0]}{" "}
          <span className="text-primary readMore" onClick={() => setreadMore1(true)}>
            more...
          </span>
        </label>
      ) : (
        <label className="mt-3">
          {studentName} {feedData["secondSection"][0][studentName]}{" "}
          <span className="text-primary readMore" onClick={() => setreadMore1(false)}>
            less
          </span>
        </label>
      )}

      {!readMore2 ? (
        <label className="mt-3">
          {studentName} {thirdSection[0]}{" "}
          <span className="text-primary readMore" onClick={() => setreadMore2(true)}>
            more...
          </span>
        </label>
      ) : (
        <label className="mt-3">
          {studentName} {feedData["thirdSection"][0][studentName]}{" "}
          <span className="text-primary readMore" onClick={() => setreadMore2(false)}>
            less
          </span>
        </label>
      )}

      <div className="emojiSection">
        <label className="labelwithIcon">
          <i className="fa fa-frown fa-2x"></i> <span>Problem noticed:</span>
        </label>
        <ol>
          {feedData["fourthSection"]["fourthSectionArray"].map((item, index) => (
            <li key={index}>{item.data}</li>
          ))}
        </ol>

        <label className="labelwithIconGood">
          <i className="fa fa-smile fa-2x"></i> <span>Going forward we will help:</span>
        </label>
        <ol>
          {feedData["fifthSection"]["fifthSectionArray"].map((item, index) => (
            <li key={index}>{item.data}</li>
          ))}
        </ol>
      </div>

      {/* More About this course Section */}
      <div id="accordion4">
        <Card
          data-toggle="collapse"
          data-target={`#opena1`}
          // onClick={() => scrollKaro()}
          className="collapsed collapseDemo homeSection"
          style={{ border: "1px #ccc solid", textAlign: "left", background: "#81d452" }}
        >
          <CardBody style={{ padding: "10px 6px" }}>
            <div className="text-left text-light d-flex justify-content-between">
              <label className="JoinText">Join another class</label>
              <div className="tutorImages">
                {availableTimings &&
                  availableTimings.map((item, index) =>
                    item.show_on_website === 0 && item.total_students > 0 ? (
                      <React.Fragment key={index}>
                        <img
                          className="ml-1"
                          src={JSON.parse(item.teachers_info)[0]["img_src"]}
                          width="40"
                          height="40"
                        />
                      </React.Fragment>
                    ) : item.show_on_website === 1 ? (
                      <React.Fragment key={index}>
                        <img
                          className="ml-1"
                          src={JSON.parse(item.teachers_info)[0]["img_src"]}
                          width="40"
                          height="40"
                        />
                      </React.Fragment>
                    ) : null
                  )}
                <span className="circleForDown">
                  <i className="fas fa-arrow-down"></i>
                </span>
              </div>
            </div>
          </CardBody>
        </Card>
        <div
          id={`opena1`}
          className="collapse collapsecourseInfoOpen"
          aria-labelledby="headingOne"
          data-parent="#accordion4"
        >
          <div className="row text-left">
            <div className="col-md-12">
              <h5 className="highlight">More about {courseDetails.course_name}</h5>

              <ul className="list-unstyled feature-list">
                {typeof courseDetails.chapters !== "undefined" && courseDetails.chapters !== 0 ? (
                  <li>
                    <i className="fas fa-graduation-cap"></i> Chapters:{" "}
                    <span>{courseDetails.chapters}</span>
                  </li>
                ) : null}

                {courseDetails.topics && courseDetails.topics !== 0 ? (
                  <li>
                    <i className="fas fa-book"></i> Topics: <span>{courseDetails.topics}</span>
                  </li>
                ) : null}

                {typeof courseDetails.videos !== "undefined" && courseDetails.videos !== 0 ? (
                  <li>
                    <i className="fas fa-play"></i> Videos: <span>{courseDetails.videos}</span>
                  </li>
                ) : null}

                {typeof courseDetails.worksheets !== "undefined" &&
                courseDetails.worksheets !== 0 ? (
                  <li>
                    <i className="fas fa-ethernet"></i> Supporting Worksheet:{" "}
                    <i className="fas fa-crown crown" style={{ color: "#DAA520" }}></i>{" "}
                    <span>{courseDetails.worksheets}</span>
                  </li>
                ) : null}

                {typeof courseDetailsTable.GroupDiscussion !== "undefined" &&
                courseDetailsTable.GroupDiscussion !== "No" ? (
                  <li>
                    <i className="fas fa-users"></i> Group Discussion:{" "}
                    <span>{courseDetailsTable.GroupDiscussion}</span>
                  </li>
                ) : null}

                {typeof courseDetailsTable.SelfLearningDashboard !== "undefined" &&
                courseDetailsTable.SelfLearningDashboard !== "No" ? (
                  <li>
                    <i className="fas fa-laptop"></i> Self Learning Dashboard:{" "}
                    <span>{courseDetailsTable.SelfLearningDashboard}</span>
                  </li>
                ) : null}

                {typeof courseDetailsTable.Certifiaction !== "undefined" &&
                courseDetailsTable.Certifiaction !== "No" ? (
                  <li>
                    <i className="fas fa-certificate"></i> Certificate:{" "}
                    <i className="fas fa-crown crown" style={{ color: "#DAA520" }}></i>{" "}
                    <span>{courseDetailsTable.Certifiaction}</span>
                  </li>
                ) : null}

                {typeof courseDetailsTable.ProgressReport !== "undefined" &&
                courseDetailsTable.ProgressReport !== "0" ? (
                  <li>
                    <i className="fas fa-tasks"></i> Progress Report:{" "}
                    <span>{courseDetailsTable.ProgressReport}</span>
                  </li>
                ) : null}

                {showMoreDetails ? (
                  <React.Fragment>
                    {typeof courseDetailsTable.Language !== "undefined" ? (
                      <li>
                        <i className="fas fa-file-excel"></i> Class Performance Report:{" "}
                        <span>{courseDetailsTable.ClassPerformanceReport}</span>
                      </li>
                    ) : null}

                    {typeof courseDetailsTable["Teacher'sReport"] !== "undefined" ? (
                      <li>
                        <i className="fas fa-chalkboard-teacher"></i> Teacher's Report:{" "}
                        <i className="fas fa-crown crown" style={{ color: "#DAA520" }}></i>{" "}
                        <span>{courseDetailsTable["Teacher'sReport"]}</span>
                      </li>
                    ) : null}

                    {typeof courseDetailsTable.Homework !== "undefined" ? (
                      <li>
                        <i className="fas fa-book-open"></i> Homework:{" "}
                        <span>{courseDetailsTable.Homework}</span>
                      </li>
                    ) : null}

                    {typeof courseDetailsTable["Before&AfterReport"] !== "undefined" &&
                    courseDetailsTable["Before&AfterReport"] !== "No" ? (
                      <li>
                        <i className="fas fa-sort-numeric-down"></i> Before & After Report:{" "}
                        <span>{courseDetailsTable["Before&AfterReport"]}</span>
                      </li>
                    ) : null}

                    {typeof courseDetailsTable.StartDate !== "undefined" &&
                    courseDetailsTable.StartDate !== "" ? (
                      <li>
                        <i className="fas fa-calendar"></i> Start Date:{" "}
                        <span>{courseDetailsTable.StartDate}</span>
                      </li>
                    ) : null}

                    {typeof courseDetailsTable.ClassDuration !== "undefined" ? (
                      <li>
                        <i className="fas fa-clock"></i>Class Duration:{" "}
                        <span>{courseDetailsTable.ClassDuration}</span>
                      </li>
                    ) : null}

                    {typeof courseDetailsTable.Frequency !== "undefined" &&
                    courseDetailsTable.Frequency !== "" ? (
                      <li>
                        <i className="fas fa-calendar-week"></i>Frequency:{" "}
                        <span>{courseDetailsTable.Frequency}</span>
                      </li>
                    ) : null}

                    {typeof courseDetailsTable.Language !== "undefined" &&
                    courseDetailsTable.Language !== "" ? (
                      <li>
                        <i className="fas fa-globe"></i> Language:{" "}
                        <span>{courseDetailsTable.Language}</span>
                      </li>
                    ) : null}

                    {typeof courseDetailsTable.SkillLevel !== "undefined" &&
                    courseDetailsTable.SkillLevel !== "" ? (
                      <li>
                        <i className="fas fa-sort-amount-up"></i> Skill Level:{" "}
                        <span>{courseDetailsTable.SkillLevel}</span>
                      </li>
                    ) : null}
                  </React.Fragment>
                ) : null}

                {showMoreDetails ? (
                  <label
                    cla
                    ssName="text-primary mt-2"
                    onClick={() => setshowMoreDetails(!showMoreDetails)}
                  >
                    see less...
                  </label>
                ) : (
                  <label
                    className="text-primary mt-2"
                    onClick={() => setshowMoreDetails(!showMoreDetails)}
                  >
                    see more...
                  </label>
                )}
              </ul>

              <div id="accordion5">
                {availableTimings &&
                  availableTimings.map((item, index) =>
                    item.show_on_website === 0 && item.total_students > 0 ? (
                      <div
                        data-toggle="collapse"
                        data-target={`#open${index}`}
                        className="collapsed timingList"
                      >
                        <div className="d-flex justify-content-between mt-3">
                          <div className="d-flex">
                            <img
                              className=""
                              src={JSON.parse(item.teachers_info)[0]["img_src"]}
                              width="40"
                              height="40"
                            />
                            <div>
                              <label className="ml-2">
                                <span>{JSON.parse(item.teachers_info)[0]["name"]}</span>
                              </label>
                              <div className="timeSection">
                                <label className="">
                                  {JSON.parse(item.Timing)[1]["start"].substring(1)} -{" "}
                                  {JSON.parse(item.Timing)[1]["end"].substring(1)}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div>
                            <button className="btn btn-light joinButton">Join</button>
                          </div>
                        </div>
                        <div
                          id={`open${index}`}
                          className="collapse"
                          style={{ padding: "10px 0" }}
                          aria-labelledby="headingOne"
                          data-parent="#accordion5"
                        >
                          <div className="text-right">
                            <span className="mr-2"> Asia/Karachi</span>
                          </div>
                          <ul className="list-unstyled daysList">
                            {returnListTimings(item.Timing)}
                          </ul>
                          <div className="row">
                            {/* <div className="col-md-7">

                                                        </div> */}
                            <div className="col-md-12">
                              <div className="priceSection">
                                <label className="text-light font-weight-bold newPrice">
                                  PKR {formatPrice(courseDetails.course_price)}
                                </label>{" "}
                                <br />
                                <span>20 classes per month (5 days a week)</span>
                                <div className="text-center">
                                  <button
                                    className="btn btn-sm btn-light mt-1"
                                    data-toggle="modal"
                                    data-target="#changeCourseModal"
                                    onClick={() => teacherSelected(item.teacher_id)}
                                  >
                                    Pay & Start
                                  </button>
                                </div>
                                <label
                                  className="text-light"
                                  data-toggle="modal"
                                  data-target="#changeCourseModal"
                                  onClick={() => teacherSelected(item.teacher_id)}
                                >
                                  I have a promo code
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : item.show_on_website === 1 ? (
                      <div
                        data-toggle="collapse"
                        data-target={`#open${index}`}
                        className="collapsed timingList"
                      >
                        <div className="d-flex justify-content-between mt-3">
                          <div className="d-flex">
                            <img
                              className=""
                              src={JSON.parse(item.teachers_info)[0]["img_src"]}
                              width="40"
                              height="40"
                            />
                            <div>
                              <label className="ml-2">
                                <span>{JSON.parse(item.teachers_info)[0]["name"]}</span>
                              </label>
                              <div className="timeSection">
                                <label className="">
                                  {JSON.parse(item.Timing)[1]["start"].substring(1)} -{" "}
                                  {JSON.parse(item.Timing)[1]["end"].substring(1)}
                                </label>
                              </div>
                            </div>
                          </div>
                          <div>
                            <button className="btn btn-light joinButton">Join</button>
                          </div>
                        </div>
                        <div
                          id={`open${index}`}
                          className="collapse timingListOpen"
                          aria-labelledby="headingOne"
                          data-parent="#accordion5"
                        >
                          <div className="text-right">
                            <span className="mr-2"> Asia/Karachi</span>
                          </div>
                          <ul className="list-unstyled daysList">
                            {returnListTimings(item.Timing)}
                          </ul>
                          <div className="row">
                            {/* <div className="col-md-7">

                                                        </div> */}
                            <div className="col-md-12">
                              <div className="priceSection">
                                <label className="text-light font-weight-bold newPrice">
                                  PKR {formatPrice(courseDetails.course_price)}
                                </label>{" "}
                                <br />
                                <span>20 classes per month (5 days a week)</span>
                                <div className="text-center">
                                  <button
                                    className="btn btn-sm btn-light mt-1"
                                    data-toggle="modal"
                                    data-target="#changeCourseModal"
                                    onClick={() => teacherSelected(item.teacher_id)}
                                  >
                                    Pay & Start
                                  </button>
                                </div>
                                <label
                                  className="text-light"
                                  data-toggle="modal"
                                  data-target="#changeCourseModal"
                                  onClick={() => teacherSelected(item.teacher_id)}
                                >
                                  I have a promo code
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null
                  )}

                <div className="modal fade" tabIndex="-1" role="dialog" id="changeCourseModal">
                  <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <label className="font-weight-bold titleModal" id="exampleModalLabel">
                          {courseDetails.course_name}
                        </label>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <CheckOutComponent
                          courseDetails={courseDetails}
                          courseId={props.courseId}
                          studentId={props.studentId}
                          programId={props.programId}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DemoFeedback;
